import {
  REGISTER_SUCCESS,
  REGISTER_FAILED,
  LOGIN_SUCCESS,
  LOGIN_FAILED,
  USER_LOADED,
  AUTH_ERROR,
  GET_ALL_USERS, LOGOUT,
} from "./types";
import axios from "axios";
import { setAlert } from "./alerts";
import setAuthToken from "../utils/setAuthToken";

// Load Logged In User
export const loadUser = () => async (dispatch) => {
  if (localStorage.token) {
    setAuthToken(localStorage.token);
  }
  try {
    const data = await axios.get("/getuser");

    dispatch({
      type: USER_LOADED,
      payload: data.data.user,
    });
  } catch (err) {
    dispatch({
      type: AUTH_ERROR,
    });
    console.log(err);
  }
};

// Register User
export const register = (
  email,
  username,
  password,
  confirm_password,
  phone_number,
  network
) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = JSON.stringify({
      email,
      username,
      password,
      confirm_password,
      phone_number,
      network,
    });

    const data = await axios.post("/createuser", body, config);
    dispatch({
      type: REGISTER_SUCCESS,
      payload: data,
    });
    dispatch(loadUser());
    dispatch(setAlert(data.data.message, "success"));
  } catch (err) {
    let errors = err.response.data.error.split(".");
    if (errors) {
      errors.forEach((error) =>
        dispatch(
          setAlert(
            error.replace('"', "").replace('"', "").toUpperCase(),
            "danger"
          )
        )
      );
    }
    dispatch({
      type: REGISTER_FAILED,
    });
    console.log(errors);
  }
};

export const login = (email, password) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = JSON.stringify({
      email,
      password,
    });
    const data = await axios.post("/loginuser", body, config);
    // console.log(data);
    dispatch({
      type: LOGIN_SUCCESS,
      payload: data,
    });
    dispatch(loadUser())
  } catch (err) {
    let errors = err.response.data.error.split(".");
    if (errors) {
      errors.forEach((error) =>
        dispatch(
          setAlert(
            error.replace('"', "").replace('"', "").toUpperCase(),
            "danger"
          )
        )
      );
    }
    dispatch({
      type: LOGIN_FAILED,
    });
    console.log(errors);
  }
};

export const getAllUsers = () => async (dispatch) => {
  try {
    let data = await axios.get("/getallusers");
    // let users = data.data.users;
    dispatch({
      type: GET_ALL_USERS,
      payload: data.data.users,
    });
    dispatch(loadUser());

  } catch (err) {
    console.log(err);
  }
};

export const logout = () => dispatch => {
  dispatch({
    type: LOGOUT
  })
}